// @flow

import type { AnyAction } from 'react-redux';
import { combineReducers } from 'redux';
import type { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import type { Loading, SearchState, Value } from '../../types';
import { setSearchValue, setLoading } from '../actions';

const setLoadingHandler = (previousValue: Loading, value: Loading): Loading =>
  value;

const setValueHandler = (previousValue: Value, value: Value): Value =>
  value
    ? value
        .toLowerCase()
        .replace(/\s/g, ' ')
        .replace(/^\/\/|^.*?:(\/\/)?/, '')
        .trim()
        .split('/')[0]
        .split(',')
        .join(' ')
    : '';

const valueReducer = createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setSearchValue]: setValueHandler,
  },
  '',
);

const loadingReducer = createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setLoading]: setLoadingHandler,
  },
  false,
);

export default (combineReducers({
  loading: loadingReducer,
  value: valueReducer,
}): Reducer<SearchState, AnyAction>);
